// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PretendAsCallerRepoConfig from "./PretendAsCallerRepoConfig.bs.js";

var callerDetailDummyUsecase1 = {
        "customer":{
          "customer_id":"0000000000",
          "customer_name":"TEST",
          "vendor_name":"Porter",
          "primary_number":"0000000000",
          "secondary_number":"0000000000"
        },
        "partners":[
          {
            "msisdn":"0000000000233",
            "uuid":"00000000",
            "partner_name":"TEST TEST",
            "primary_number":"0000000000",
            "secondary_number":"0000000000",
            "owner_number":"0000000000"
          },
          {
            "msisdn":"0000000000000",
            "uuid":"00000000",
            "partner_name":"TEST",
            "primary_number":"0000000000",
            "secondary_number":"0000000000",
            "owner_number":"0000000000"
          }
        ]
      };

function fetchCallerDetails(caller_number, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: callerDetailDummyUsecase1
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(PretendAsCallerRepoConfig.PretendAsCallerResponseConverter.execute, result);
                        });
            });
}

var PretendAsCallerRepo = {
  fetchCallerDetails: fetchCallerDetails
};

export {
  PretendAsCallerRepo ,
  
}
/* PretendAsCallerRepoConfig Not a pure module */
